module.exports = __webpack_public_path__ + "img/masterImage_1@3x.b89468c0.png";